import { render, staticRenderFns } from "./RevisionSelector.vue?vue&type=template&id=38fa55fe"
import script from "./RevisionSelector.vue?vue&type=script&lang=js"
export * from "./RevisionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports